import { ChangeEvent, FC } from 'react'
interface InputFileProps {
    name: string
    label: string
    document:
        | {
              docType: string
              file: File
          }
        | undefined
    handleFileChange(e: ChangeEvent<HTMLInputElement>): void
}
export const InputFile: FC<InputFileProps> = ({
    name,
    label,
    document,
    handleFileChange,
}) => {
    return (
        <div className="flex flex-col gap-1">
            <span className="tracking-tight">
                {label} <span className="text-red-500">*</span>
            </span>
            <label
                htmlFor={name}
                className="bg-gray-400 p-1 rounded-md shadow-sm flex gap-4 items-center cursor-pointer"
            >
                <span className="bg-white rounded-md p-1 px-2 font-medium">
                    Escolher arquivo
                </span>
                <span className="text-gray-700 font-medium">
                    {document
                        ? `${document.file.name}`
                        : 'Nenhum arquivo selecionado'}
                </span>
            </label>
            <input
                type="file"
                id={name}
                name={name}
                className="sr-only"
                onChange={handleFileChange}
            />
        </div>
    )
}
